
import { Game, Board, FLAGGED } from './Minesweeper';

const debug = false;

interface GameBoard {
  game: Game;
  board: Board;
  lost: boolean;
  won: boolean;
  flagging: boolean;
  selectSquare: (x: number, y: number) => void;
  toggleFlagSquare: (x: number, y: number) => void;
  clearFlagging: () => void;
}


function GameBoard(props: GameBoard) {
  const { game, selectSquare, lost, won, board, toggleFlagSquare, flagging, clearFlagging } = props;

  const renderRows = () => {
    const rows = [];
    for(let i = 0; i < game.length; i++) {
      const cells = [];
      for(let j = 0; j < game[i].length; j++) {
        const val = game[i][j];
        const key = `mine-board-cell-${j}-${i}`;
        const click = (ele: React.MouseEvent<HTMLDivElement>) => { 
          
          if (flagging || ele.altKey) {
            (val === -1 || val === FLAGGED) && !lost && toggleFlagSquare(j, i); 
            flagging && clearFlagging();      
          }
          else {
            (val === -1) && !lost && selectSquare(j, i); 
          }
        };
        let css = `mine-board-cell value-style-${val} ${won||lost? 'game-over':''} ${flagging ? 'flagging':''}`;
        let text  =  val > -1 ? val  : '';
        if( board[i][j] && (won || lost) ) {
          text =  '💣';
        }
        if (game[i][j] === FLAGGED && !won && !lost) {
          text = '⛳';
        }
        const cell =
          <div 
            className={css}
            key={key}
            onClick={click}
          >
            {text}
          </div>; 
        cells.push(cell)
      }
      const row = <div className="mine-board-row" key={`mine-board-row-${i}`}>{cells}</div>
      rows.push(row);
    }
    return rows;
  };

  const renderRowsDebug = (_game = false) => {
    const todraw = _game ? game : board; 
    const rows = [];
    for(let i = 0; i < todraw.length; i++) {
      const cells = [];
      for(let j = 0; j < todraw[i].length; j++) {
        const val = todraw[i][j];
        const key = `mine-board-cell-${j}-${i}`;
        const text = _game ? val : (val ? 1 : 0)
        const cell =
          <div 
            className={`mine-board-cell value-style-${val}}`}
            key={key}
          >
            {text}
          </div>; 
        cells.push(cell)
      }
      const row = <div className="mine-board-row" key={`mine-board-row-${i}`}>{cells}</div>
      rows.push(row);
    }
    return rows;
  };

  return <>
    <div className="mine-board">
      {renderRows()}
    </div>
    { debug && <div className="mine-board">
      {renderRowsDebug(false)}
    </div> }
  </>;
}

export default GameBoard;